const displayId = (id: string): string => {
  const testMode = !import.meta.env.PROD && import.meta.env.VITE_TEST_MODE;
  return testMode ? "fixed-id-for-testing" : id;
};

export default displayId;
